import { EVENTS_LIVE_CHAT, MESSAGES, MODE } from '../../constants';
import { isObject } from '../../util/guards';
import {
  agentReplied,
  agentStatus,
  chatTransferred,
  createAIArticleAnswer,
  createArticle,
  createArticleSelector,
  createBotMessage,
  createBotTyping,
  createButtons,
  createCategory,
  createDomainSelector,
  createImage,
  createInvoiceSelector,
  createLoginSelector,
  createModeMessage,
  createPhoneSelector,
  createSiteSelector,
  createTitleBotMessage,
  createUserAccountsSelector,
  createUserMessage,
  createVideo,
  createWhitelabelSelector,
  waitingForAgent,
} from '../common/messageCreators';
import { createGeneratedAnswerMessage } from '../common/messageCreators/answerGeneration';
import { TItem } from '../common/reducers/types';

export const isLiveChatMode = (mode: unknown): boolean => {
  return mode === MODE.LIVECHAT || mode === 'LIVECHAT';
};

export const createChatMessage = (payload: unknown): TItem | undefined => {
  if (!isObject(payload)) {
    return;
  }

  switch (payload.type) {
    case MESSAGES.BOT_MESSAGE: {
      return createBotMessage(payload);
    }

    case MESSAGES.TITLE_BOT_MESSAGE: {
      return createTitleBotMessage(payload);
    }

    case MESSAGES.AI_ARTICLE_ANSWER: {
      return createAIArticleAnswer(payload);
    }

    case MESSAGES.ANSWER_GENERATION: {
      return createGeneratedAnswerMessage(payload);
    }

    case MESSAGES.USER_MESSAGE: {
      return createUserMessage(payload, Boolean(payload.isLiveChat));
    }

    case MESSAGES.ARTICLE: {
      return createArticle(payload);
    }

    case MESSAGES.BUTTONS:
    case MESSAGES.BUTTONS_VERTICAL: {
      return createButtons(payload);
    }

    case MESSAGES.PHONE: {
      return createPhoneSelector(payload);
    }

    case MESSAGES.CATEGORY: {
      return createCategory(payload);
    }

    case MESSAGES.SITE_SELECTOR: {
      return createSiteSelector(payload);
    }

    case MESSAGES.DOMAIN_SELECTOR: {
      return createDomainSelector(payload);
    }

    case MESSAGES.ARTICLE_SELECTOR: {
      return createArticleSelector(payload);
    }

    case MESSAGES.INVOICE_SELECTOR: {
      return createInvoiceSelector(payload);
    }

    case MESSAGES.USER_ACCOUNTS_SELECTOR: {
      return createUserAccountsSelector(payload);
    }

    case MESSAGES.WHITELABEL_SELECTOR: {
      return createWhitelabelSelector(payload);
    }

    case MESSAGES.VIDEO: {
      return createVideo(payload);
    }

    case MESSAGES.IMAGE: {
      return createImage(payload);
    }

    case MESSAGES.LOGIN_SELECTOR: {
      return createLoginSelector(payload);
    }

    case MESSAGES.BOT_TYPING: {
      return createBotTyping({ rm: true });
    }
    /* Live Chat */
    case MESSAGES.CHANGE_MODE: {
      return createModeMessage(payload);
    }

    case EVENTS_LIVE_CHAT.AGENT_REPLIED: {
      return agentReplied(payload);
    }

    case EVENTS_LIVE_CHAT.AGENT_JOINED:
    case EVENTS_LIVE_CHAT.AGENT_LEFT: {
      const isJoined = payload.type === EVENTS_LIVE_CHAT.AGENT_JOINED;

      return agentStatus(payload, isJoined);
    }

    case EVENTS_LIVE_CHAT.CHAT_TRANSFERRED: {
      return chatTransferred(payload);
    }

    case EVENTS_LIVE_CHAT.WAITING_FOR_AGENT: {
      return waitingForAgent(payload);
    }

    default:
      return;
  }
};
